import { Navigate } from "react-router-dom";
import { KNOWLEDGE_BASE_PATH } from "../paths";

/**
 * An address from the Review area, removed on 30 October 2026 (the review queue, its rows and its browse views), or a
 * row's address from before it: they all land on the Knowledge Base, where the confirmed diagnostics are.
 */
export default function OldAddressRedirect() {
  return <Navigate to={KNOWLEDGE_BASE_PATH} replace />;
}
